// NGRX
import { createFeatureSelector } from '@ngrx/store';
import { EntityState, EntityAdapter, createEntityAdapter, Update } from '@ngrx/entity';
// Actions
import { PatientActions, PatientActionTypes } from '../_actions/patient.actions';
// Models
import { PatientModel } from '../_models/patient.model';
import { QueryParamsModel } from '../../_base/crud';

export interface PatientsState extends EntityState<PatientModel> {
  listLoading: boolean;
  actionsloading: boolean;
  totalCount: number;
  lastCreatedPatientId: number;
  lastCreatedPatient: PatientModel;
  lastQuery: QueryParamsModel;
  showInitWaitingMessage: boolean;
  latestSuccessfullAction: any;
  error: any | null;
}

export const adapter: EntityAdapter<PatientModel> = createEntityAdapter<PatientModel>();

export const initialPatientsState: PatientsState = adapter.getInitialState({
  patientForEdit: null,
  listLoading: false,
  actionsloading: false,
  totalCount: 0,
  lastCreatedPatientId: undefined,
  lastCreatedPatient: undefined,
  lastQuery: new QueryParamsModel({}),
  showInitWaitingMessage: true,
  error: null,
  latestSuccessfullAction: null,
});

export function patientsReducer(
  state = initialPatientsState,
  action: PatientActions,
): PatientsState {
  switch (action.type) {
    case PatientActionTypes.PatientsPageToggleLoading: {
      return {
        ...state,
        listLoading: action.payload.isLoading,
        lastCreatedPatientId: undefined,
      };
    }
    case PatientActionTypes.PatientActionToggleLoading: {
      return {
        ...state,
        actionsloading: action.payload.isLoading,
      };
    }
    case PatientActionTypes.PatientOnServerCreated:
      return {
        ...state,
      };
    case PatientActionTypes.PatientCreated:
      return adapter.addOne(action.payload.patient, {
        ...state,
        lastCreatedPatientId: action.payload.patient.id,
        lastCreatedPatient: action.payload.patient,
      });
    case PatientActionTypes.PatientUpdated:
      return adapter.updateOne(action.payload.partialPatient, state);
    case PatientActionTypes.PatientStatusUpdated: {
      // tslint:disable-next-line
      const _partialPatient: Update<PatientModel> = {
        id: action.payload.patient.id,
        changes: {
          is_active: action.payload.is_active,
        },
      };
      // tslint:disable-next-line:prefer-const
      // tslint:disable-next-line
      return adapter.updateOne(_partialPatient, state);
    }
    case PatientActionTypes.PatientsStatusUpdated: {
      // tslint:disable-next-line
      const _partialPatients: Update<PatientModel>[] = [];
      // tslint:disable-next-line:prefer-const
      // tslint:disable-next-line
      for (let i = 0; i < action.payload.patients.length; i++) {
        _partialPatients.push({
          id: action.payload.patients[i].id,
          changes: {
            is_active: action.payload.is_active,
          },
        });
      }
      return adapter.updateMany(_partialPatients, state);
    }
    case PatientActionTypes.OnePatientDeleted:
      return adapter.removeOne(action.payload.id, state);
    case PatientActionTypes.ManyPatientsDeleted:
      return adapter.removeMany(action.payload.ids, state);
    case PatientActionTypes.PatientsPageCancelled: {
      return {
        ...state,
        listLoading: false,
        lastQuery: new QueryParamsModel({}),
      };
    }
    case PatientActionTypes.PatientsPageLoaded: {
      return adapter.addMany(action.payload.patients, {
        ...initialPatientsState,
        totalCount: action.payload.totalCount,
        listLoading: false,
        lastQuery: action.payload.page,
        showInitWaitingMessage: false,
      });
    }
    case PatientActionTypes.ThrowPatientError: {
      return {
        ...state,
        error: action.payload.error,
        actionsloading: false,
        listLoading: false,
      };
    }
    case PatientActionTypes.ClearPatientErrors: {
      return {
        ...state,
        error: null,
      };
    }
    case PatientActionTypes.FirePatientSuccess: {
      return {
        ...state,
        latestSuccessfullAction: { action_type: action.payload.action_type },
        error: null,
      };
    }
    default:
      return state;
  }
}

export const getPatientState = createFeatureSelector<PatientModel>('patients');

export const { selectAll, selectEntities, selectIds, selectTotal } = adapter.getSelectors();
